
<template>
    <li class="NavHeaderItems">
        <RouterLink
            :to="to"
            class="Link"
            :class="{ hover }"
            v-bind="attrs"
        >
            <WIcon
                v-if="icon"
                :icon="icon"
                :size="20"
            />
            <Transition
                name="fade"
                mode="out-in"
            >
                <WText
                    tag="span"
                    weight="semi"
                    :size="16"
                >
                    {{ label }}
                </WText>
            </Transition>
        </RouterLink>

        <ul
            v-if="children"
            class="SubLinks"
        >
            <li
                v-for="({ to: subTo, label: subLabel }, subIndex) in children"
                :key="`navSubLink-${subIndex}`"
            >
                <RouterLink
                    :to="subTo"
                    class="Link secondary"
                >
                    <Transition
                        name="fade"
                        mode="out-in"
                    >
                        <WText
                            tag="span"
                            weight="semi"
                            :size="16"
                        >
                            {{ subLabel }}
                        </WText>
                    </Transition>
                </RouterLink>
            </li>
        </ul>
    </li>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'NavHeaderItems',
    props: {
        to: VueTypes.object,
        attrs: VueTypes.any,
        icon: VueTypes.string.required,
        label: VueTypes.string.required,
        children: VueTypes.array.def(undefined),
    },
    data () {
        return {
            hover: false,
        }
    },
    methods: {
        handleToggleHover () {
            this.hover = !this.hover
        },
    },
}
</script>

<style lang="scss" scoped>
ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.Link {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 44px;
    height: 100%;
    padding: 0 15px;
    font-family: $font-family-sans-serif;
    font-size: 14px;
    text-transform: uppercase;
    transition: all 350ms ease;

    &:hover {
        background-color: rgba($primary, .15);
    }

    .WIcon {
        color: $white;
        margin: 0 15px 0 5px;
    }

    .WText {
        display: block;
        color: $white;
        line-height: 1.25;
        transition: color .3s ease-out;
    }

    &.secondary {
        display: flex;
        background-color: transparent;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        .WText {
            color: $white;
            white-space: nowrap;
        }

        &:hover {
            background-color: rgba($white, .15);

            .WText {
                color: $white;
            }
        }
    }
}

.NavHeaderItems {
    position: relative;

    &:hover {
        .SubLinks {
            display: block;
        }

        & > .Link {
            background-color: rgba($primary, .15);
        }
    }
}

.SubLinks {
    display: none;
    position: absolute;
    left: 0;
    background: $black;
    border-left: solid 1px rgba($white, 0.2);
    border-right: solid 1px rgba($white, 0.2);
    border-bottom: solid 1px rgba($white, 0.2);
    box-shadow: 0 3px 6px 0 rgba($black, 0.3);
    border-bottom-left-radius: $border-radius;
    border-bottom-right-radius: $border-radius;

    li {
        min-width: 220px;
        width: auto;
        height: 100%;
    }
}
</style>
